export default {
  one: "Cave One",
  two: "Cave Two",
  three: "Cave Three",
  type: "entrance",
  equipment: "visible"
};
